module.exports = __webpack_public_path__ + "media/Covid-19.c4d9fa4a.mp4";